import React from 'react'
import './LiveEditor.css'
import videojs from 'video.js'
import Axios from 'axios'
import icon_help from './img/icon-help.png'
import {PlusOutlined} from "@ant-design/icons";
import {message, Popover, Button, Input} from 'antd';

const text = <span>Title</span>;
const content = (
    <div className="live-manager-layout-left-content-right-tl-and-password-hint">
        将服务器与串流密钥粘贴复制至直播软件>设置>推流 中，默认自定义服务。
    </div>
);
export default class LiveEditor extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            userId: props.userId,
            userName: props.userName,

            liveId: props.liveId,
            pullPath: props.pullPath,
            liveName: props.liveName,//直播间名称
            liveCover: props.liveCover,//直播间封面
            hostId: props.hostId,
            liveNotice: props.liveNotice,
            groupId: props.groupId,

            liveUrl: "",//服务器地址
            liveUrlPassword: "",//串流密钥
            liveCover2: "",//暂时存储头像地址

            isLoaded: false,
            liveStatus: props.liveStatus,//当前是否处于直播状态
            isSaveFlag: false,//只能保存一次
        }
        this.hostName = React.createRef();
        this.avatar = React.createRef();
        this.inputRef = React.createRef();
        this.fileRef = React.createRef();
        this.image = React.createRef();
        this.announcement = React.createRef();
    }

    async componentWillMount() {
        const {
            userId, userName,
            liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
            liveStatus, isLoaded
        } = this.state;
        if (pullPath !== "") {//如果已经有直播间
            await this.setState({isLoaded: true, liveStatus: true});
            this.createPlayer("my-player", pullPath, liveNotice, liveId, userId === hostId);//创建播放器
        } else {
            await this.getLiveUrlAndPassword();
            await this.setState({isLoaded: true});
        }
    }

    /**
     * 查看是否有已经有直播间
     * @returns {*}
     * liveId\pullPath\liveName\liveCover\hostId\liveNotice\groupId
     */
    searchLiveRoom = async () => {
        const apiRoot = `${global.url.live}/live/search`;
        let data;
        await Axios.get(apiRoot).then(res => {
            data = res.data.payload;
        });
        return data;
    }

    /**
     * 创建聊天室
     * @param userId 用户ID
     * @param userName 用户名
     * @returns {string} 返回群号 groupId
     */
    createGroup = async (userId, userName) => {
        const apiRoot = `${global.url.im}/group/create`;
        const data = {};
        data.groupOwnerId = userId;
        data.groupOwnerName = userName;
        data.groupType = "直播间";
        data.groupName = "直播间";
        data.groupAvatar = "test....";
        data.members = [];

        let groupId = "";
        await Axios.post(apiRoot, data).then(res => {//创建群聊
            groupId = res.data.payload.groupId;
        });
        return groupId;
    }

    /**
     * 创建直播间
     * @param groupId 群号
     * @param hostId 用户id
     * @param hostName 用户名
     * @param liveCover 直播间封面
     * @param liveToken 密钥
     * @param serverPath 服务器地址
     * @param liveName 直播间名称
     * @param liveNotice 直播间公告
     * @returns {*}
     */
    createLiveRoom = async (groupId, hostId, hostName, liveCover, liveToken, serverPath, liveName, liveNotice) => {
        const apiRoot = `${global.url.live}/live/create`;
        const data = {};
        data.groupId = groupId;//群号
        data.hostId = hostId;//用户ID
        data.hostName = hostName;//用户名
        data.liveCover = liveCover;//用户头像
        data.liveName = liveName;//直播间名字
        data.liveNotice = liveNotice;//直播间公告
        data.liveToken = liveToken;//串流密钥
        data.serverPath = serverPath;//服务器地址
        let data2;
        await Axios.post(apiRoot, data).then(res => {
            data2 = res.data.payload;
        });
        return data2;
    }

    /**
     * 创建播放器
     * @param elementId video.js组件的ID
     * @param pushPath 推流的地址
     * @param liveNotice 公告
     * @param liveId 直播间Id
     * @param ishost 是否是主播
     */
    createPlayer = (elementId, pushPath, liveNotice, liveId, ishost) => {
        // videojs 方法接收 3 个参数，
        // 第一个是 dom 节点的 ID 名称
        // 第二个是一些配置项的内容
        // 第三个则是自定义插件的配置，通常会在 videojs 挂载后执行，也可以理解为 videojs 的 mounted 阶段
        const player = videojs(document.getElementById(elementId),
            {
                controls: true, //是否显示控件
                preload: 'auto',//预加载视频数据
                autoplay: true, //自动开始播放
                fluid: false,   //关闭自适应宽高
                height: 580,    //设置高度 580px
                width: 1020,    //设置宽度 1020px
                language: 'zh-CN', // 设置语言
                overrideNative: false,//放hls协议直播,对7.10.0之后的video.js很重要
                controlBar: { // 设置控制条组件
                    /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
                    children: [
                        {name: 'playToggle'}, // 播放按钮
                        {name: 'progressControl'}, // 播放进度条
                        {name: 'currentTimeDisplay'},// 当前已播放时间
                    ]
                },
                sources: [ // 视频源
                    {
                        src: pushPath,
                        type: 'application/x-mpegURL',
                    }
                ]
            },
            function () {//自定义组件
                const Component = videojs.getComponent('Component');
                //公告栏
                {
                    const TitleBar = videojs.extend(Component, {
                        constructor: function (player, options) {
                            Component.apply(this, arguments);
                            if (options.text) {
                                this.updateTextContent(options.text);
                            }
                        },
                        createEl: function () {
                            return videojs.dom.createEl('div', {
                                className: 'vjs-title-bar'
                            });
                        },
                        updateTextContent: function (text) {
                            if (typeof text !== 'string') {
                                text = 'Title Unknown';
                            }
                            videojs.emptyEl(this.el());
                            videojs.appendContent(this.el(), text);
                        }
                    });
                    videojs.registerComponent('TitleBar', TitleBar);

                    const player = videojs('my-player');
                    player.addChild('TitleBar', {text: liveNotice});//加入公告栏
                }
                //最底层的控制栏
                {
                    const FooterBar = videojs.extend(Component, {
                        constructor: function (player, options) {
                            Component.apply(this, arguments);
                        },
                        createEl: function () {
                            const divObj = videojs.dom.createEl('div', {
                                className: 'vjs-footer-bar',
                            });
                            return divObj;
                        },
                    });
                    videojs.registerComponent('FooterBar', FooterBar);
                    player.addChild('FooterBar');//加入最底层的控制栏
                }
                //继承音量面板控件，并插入到最底层的控制栏中
                {
                    const volumePanel = videojs.getComponent('volumePanel');// 获取音量面板控件
                    const myVolumePanel = videojs.extend(volumePanel, {
                        constructor: function (player, options) {
                            Component.apply(this, arguments);
                            this.handleKeyPressHandler_ = (e) => this.handleKeyPress(e);
                            this.removeClass('vjs-volume-panel-vertical');
                            this.removeClass('vjs-volume-panel-horizontal');
                            this.addClass('vjs-hover');
                            this.on(this.muteToggle, 'keyup', (e) => this.handleKeyPress(e));
                            this.on(this.volumeControl, 'keyup', (e) => this.handleVolumeControlKeyUp(e));
                            this.on('keydown', (e) => this.handleKeyPress(e));
                            this.on(this.volumeControl, ['slideractive'], this.sliderActive_);
                            this.on(this.volumeControl, ['sliderinactive'], this.sliderInactive_);
                        },

                    });
                    videojs.registerComponent('volumePanel', myVolumePanel);//注册音量面板控件
                    player.getChild('FooterBar').addChild('volumePanel');// 找到 FooterBar 节点，添加控件
                }
                //自定义结束直播按钮，并插入到最底层的控制栏中
                {
                    const CloseLive = videojs.extend(Component, {
                        constructor: function (player, options) {
                            Component.apply(this, arguments)
                            this.on('click', this.closeLive);
                        },
                        createEl: function () {
                            const divObj = videojs.dom.createEl('div', {
                                className: 'vjs-close-live',
                                innerHTML: '结束直播',
                            });
                            return divObj;
                        },
                        closeLive: async function () {//结束直播
                            const apiRoot = `${global.url.live}/live/del`;//live/close 关闭直播间
                            await Axios.delete(apiRoot, {params: {liveId: liveId}}).then(res => {
                                console.log(res);
                            });
                            if (window.confirm("关闭直播间还需要手动关闭OBS推流工具！")) {
                                window.location.reload();
                            }
                        },
                    })
                    videojs.registerComponent('ClosedLive', CloseLive);
                    // 找到 controlBar 节点，添加控件（如果是主播）
                    if (ishost) {
                        player.getChild('FooterBar').addChild('ClosedLive');
                    }
                }
            }
        );
    }

    /**
     * 获取服务器地址、串流密钥,并保存到state
     */
    getLiveUrlAndPassword = () => {
        const apiRoot = `${global.url.live}/live/getliveinfo`
        Axios.get(apiRoot)
            .then(res => {
                const data = res.data.payload;
                this.setState({liveUrl: data.serverPath, liveUrlPassword: data.liveToken});
            })
    }

    /**
     * 复制服务器地址到剪贴板
     */
    handleCopyLiveUrl = () => {
        let copydata = document.getElementById("liveurl").innerHTML;
        let input = document.createElement("textarea");
        input.innerHTML = copydata;
        document.body.appendChild(input);
        input.select();
        let result = document.execCommand("copy");
        document.body.removeChild(input);
        return result;
    }

    /**
     * 复制串流密钥到剪贴板
     */
    handleCopyLivePassword = () => {
        let copydata = document.getElementById("password").innerHTML;
        let input = document.createElement("textarea");
        input.innerHTML = copydata;
        document.body.appendChild(input);
        input.select();
        let result = document.execCommand("copy");
        document.body.removeChild(input);
        return result;
    }

    /**
     * 分享链接
     * @returns {boolean} 返回直播间的URL地址
     */
    handleShareLiveRoom = () => {
        let copydata = window.location.href;
        let input = document.createElement("textarea");
        input.innerHTML = copydata;
        document.body.appendChild(input);
        input.select();
        let result = document.execCommand("copy");
        document.body.removeChild(input);
        alert('已复制直播间地址')
        return result;
    }

    /**
     * 上传封面，并保存到state.liveCover2
     */
    handleUploadCover = () => {
        let data = new FormData();
        data.append("file", this.fileRef.current.files[0]);

        const apiRoot = `${global.support.ossUpload}/oss/upload`;
        Axios.post(apiRoot, data)
            .then(res => {
                const fileUrl = res.data.payload;
                console.log(`${window.serviceUrl.fileServerImg}` + '/' + fileUrl);

                this.image.current.style.background = `url(${window.serviceUrl.fileServerImg + '/' + fileUrl}) no-repeat`;
                this.image.current.style.backgroundSize = 'cover';
                this.setState({liveCover2: `${window.serviceUrl.fileServerImg}` + '/' + fileUrl});
            });
    }

    /**
     * 保存按钮，提交表单, 创建直播间
     */
    handleSubmit = async () => {
        if (!this.state.liveCover2 || !this.inputRef.current.value || !this.announcement.current.value) {
            alert("创建直播间，请先填写完整信息，然后待封面上传成功后保存");
            return;
        }

        await this.setState({
            liveCover: this.state.liveCover2,
            liveName: this.inputRef.current.value,
            liveNotice: this.announcement.current.value,
            isSaveFlag: true
        });//保存直播间的封面，直播间名称，直播间公告
        this.avatar.current.style.background = `url(${this.state.liveCover}) no-repeat`;
        this.avatar.current.style.backgroundSize = 'cover';

        // const { userId, userName,
        //     liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
        //     liveUrl, liveUrlPassword,
        //     liveStatus, isLoaded } = this.state;
        // let _groupId = await this.createGroup(userId, userName);//获取群号
        // let _data = await this.createLiveRoom(_groupId, userId, userName, liveCover, liveUrlPassword, liveUrl, liveName, liveNotice);//创建直播间
        // this.setState({ liveId: _data.liveId, pullPath: _data.pullPath, liveName: _data.liveName, liveCover: _data.liveCover, hostId: _data.hostId, liveNotice: _data.liveNotice, groupId: _data.groupId });//保存直播间的id和pullpath
    }

    /**
     * 开启直播
     */
    openLive = async () => {
        const {
            userId, userName,
            liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
            liveUrl, liveUrlPassword,
            liveStatus, isLoaded
        } = this.state;

        let _groupId = await this.createGroup(userId, userName);//获取群号
        let _data = await this.createLiveRoom(_groupId, userId, userName, liveCover, liveUrlPassword, liveUrl, liveName, liveNotice);//创建直播间
        this.setState({
            liveId: _data.liveId,
            pullPath: _data.pullPath,
            liveName: _data.liveName,
            liveCover: _data.liveCover,
            hostId: _data.hostId,
            liveNotice: _data.liveNotice,
            groupId: _data.groupId
        });//保存直播间的id和pullpath
        let data = await this.searchLiveRoom();//获取已有的直播间信息
        console.log('', liveName);
        console.log('获取已有的直播间信息:s', data);
        // debugger
        if (data) {
            await this.setState({
                liveStatus: true,
                liveId: data.liveId,
                pullPath: data.pullPath,
                liveName: data.liveName,
                liveCover: data.liveCover,
                hostId: data.hostId,
                liveNotice: data.liveNotice,
                groupId: data.groupId
            });//更新state

            const {
                userId, userName,
                liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
                liveUrl, liveUrlPassword,
                liveStatus, isLoaded
            } = this.state;
            this.createPlayer("my-player", pullPath, liveNotice, liveId, userId === hostId);//创建播放器
            await this.props.setLiveInfo(true, liveId, groupId);
        } else {
            message.error('请填写直播间信息！！！！')
        }

    }

    render() {
        const {
            userId, userName,
            liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
            liveStatus, isLoaded
        } = this.state;

        if (!isLoaded) {
            return <div className="App"/>;
        }
        if (liveStatus) {
            return (
                <React.Fragment>
                    <div className="live-manager-layout-left-header">
                        {/*头像 */}
                        <div className="live-manager-layout-left-header-avatar" ref={this.avatar}
                             style={{background: `url(${liveCover})`, backgroundSize: 'cover'}}/>
                        {/* ***的直播间 */}
                        <div className="live-manager-layout-left-header-title">
                            <p className="live-manager-layout-left-header-title-home" ref={this.hostName}>
                                {liveName}
                            </p>
                            <p className="live-manager-layout-left-header-title-host">
                                {hostId}
                            </p>
                        </div>
                        <div className="live-manager-layout-left-header-share"
                             onClick={this.handleShareLiveRoom}>
                            分享
                        </div>
                    </div>
                    <video id="my-player" className="video-js video_window_box">
                        <p className="vjs-no-js">
                            要观看此视频，请启用 JavaScript，并考虑升级到网络浏览器
                            <a href="https://videojs.com/html5-video-support/" target="_blank">
                                支持 HTML5 视频
                            </a>
                        </p>
                    </video>
                </React.Fragment>
            )
        }
        if (!liveStatus) {
            return (
                <React.Fragment>
                    <div className="live-manager-layout-left-header">
                        {/*头像*/}
                        <div className="live-manager-layout-left-header-avatar" ref={this.avatar}
                             style={{background: `url(${liveCover})`, backgroundSize: 'cover'}}/>
                        {/* ***的直播间 */}
                        <div className="live-manager-layout-left-header-title">
                            <p className="live-manager-layout-left-header-title-home" ref={this.hostName}>
                                {!this.state.liveName && <React.Fragment>
                                    {`${userName}的直播间`}
                                </React.Fragment>}
                                {this.state.liveName && <React.Fragment>
                                    {this.state.liveName}
                                </React.Fragment>}
                            </p>
                            <p className="live-manager-layout-left-header-title-host">
                                {userName}
                            </p>
                        </div>
                    </div>
                    {/*主要内容*/}
                    <div className="live-manager-layout-left-content" id="live-view">
                        {/*设置*/}
                        <div className="live-manager-layout-left-content-left">
                            设&nbsp;&nbsp;置
                        </div>

                        <div className="live-manager-layout-left-content-right">
                            <div className="live-manager-layout-left-content-right-top">
                                {/*服务器和串流密钥*/}
                                <div className="live-manager-layout-left-content-right-tl-and-password">
                                    <div className="live-manager-layout-left-content-right-tl">
                                        <span className="live-manager-layout-left-content-right-tl-url">服务器：</span>
                                        <span id="liveurl">{this.state.liveUrl}</span>
                                        <span id="copyLiveURL" className="live-manager-layout-left-content-right-p-copy"
                                              onClick={this.handleCopyLiveUrl}>
                                            复制
                                        </span>
                                    </div>
                                    <div className="live-manager-layout-left-content-right-password">
                                        <span
                                            className="live-manager-layout-left-content-right-tl-password">串流密钥：</span>
                                        <span id="password">{this.state.liveUrlPassword}</span>
                                        <span id="copyPassword"
                                              className="live-manager-layout-left-content-right-p-copy"
                                              onClick={this.handleCopyLivePassword}>
                                            复制
                                        </span>
                                    </div>
                                </div>
                                <Popover placement="right" content={content} trigger="click">
                                    <img src={icon_help} style={{
                                        width: '20px',
                                        height: '20px',
                                        margin: "2% 1.5%",
                                        cursor: 'pointer'
                                    }}></img>
                                </Popover>
                            </div>

                            {/*分割线*/}
                            <div className="divider"/>

                            {/*直播间名称*/}
                            <p className="live-manager-layout-left-content-right-p">
                                <span>直播间名称：</span>
                                <span className="live-manager-layout-left-content-right-p-insert">
                                    <input placeholder="请输入名称" ref={this.inputRef} />


                                </span>
                                {/*<Input placeholder="请输入名称" ref={this.inputRef} bordered={true}/>*/}


                            </p>

                            {/*直播间封面*/}
                            <div className="live-manager-layout-left-content-right-p live-manager-fileupload">
                                <span>直播间封面：</span>
                                <div className="live-manager-layout-left-content-right-p-upload" ref={this.image}>
                                    <div className="live-manager-layout-left-content-right-p-upload-icon">
                                        <PlusOutlined style={{fontSize: "36px"}}/>
                                    </div>
                                    <div className="live-manager-layout-left-content-right-p-upload-desc">
                                        上传封面
                                    </div>
                                    <input type="file" accept="image/*" ref={this.fileRef}
                                           onChange={this.handleUploadCover}/>
                                </div>
                                {/* {
                            this.state.liveCover !== "" && <div className="live-manager-layout-left-content-right-p-upload-preview" style={{background:`url(${this.state.liveCover}) no-repeat`}}>
                            </div>
                        } */}
                            </div>

                            {/*公告*/}
                            <p className="live-manager-layout-left-content-right-p">
                                <span className="">公告：</span>
                                <span className="live-manager-layout-left-content-right-p-insert">
                                    <input placeholder="设置公告提示信息，限50个字" ref={this.announcement}/>
                                </span>
                            </p>

                            {/*保存按钮*/}
                            <div className="live-manager-layout-left-content-right-keep" onClick={this.handleSubmit}>
                                保存
                            </div>

                        </div>
                    </div>

                    {/*分割线*/}
                    <div className="divider2"/>

                    {/*底部*/}
                    <div className="live-manager-layout-left-footer">
                        {/*开始直播*/}
                        <div className="live-manager-layout-left-footer-btn live-manager-layout-left-footer-start"
                             onClick={this.openLive}>
                            开始直播
                        </div>
                        {/*下载直播软件*/}
                        <div className="live-manager-layout-left-footer-btn live-manager-layout-left-footer-download">
                            <div className="live-manager-layout-left-footer-download-icon">
                                <img src={require('./img/icon-client.png')}></img>
                            </div>
                            <div className="live-manager-layout-left-footer-download-desc">
                                <a href="https://obsproject.com/download" target="_blank">
                                    下载直播软件
                                </a>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}
